import { Skils,SkilsTitle,SkilsText,SkilsUl,SkilsLi,SkilsLiUl,SkilsLiLi } from "./styled/skils-styled";
import html from '../icon/html.png';
import css from '../icon/css.png';
import js from '../icon/js.png';
import react from '../icon/react.png';
import figma from '../icon/figma.png';
import github from '../icon/github.png';
import git from '../icon/git.png';
import ps from '../icon/ps.png';
import BlackStar from '../icon/BlackStar.png';
import WhiteStart from '../icon/WhiteStart.png';
export default function Skilse(){
    return(
        <Skils >
                                    <h1>Изучал</h1>
                    <SkilsUl>
                        <SkilsLi>
                            <img src={html} alt="" width='60px' height='60px' />
                            <SkilsText>HTML</SkilsText>
                            <SkilsLiUl>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                            </SkilsLiUl>
                        </SkilsLi>
                        <SkilsLi>
                            <img src={css} alt="" width='60px' height='60px' />
                            <SkilsText>CSS</SkilsText>
                            <SkilsLiUl>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                            </SkilsLiUl>
                        </SkilsLi>
                        <SkilsLi>
                            <img src={js} alt="" width='60px' height='60px' />
                            <SkilsText>JavasCript</SkilsText>
                            <SkilsLiUl>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={WhiteStart} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                            </SkilsLiUl>
                        </SkilsLi>
                        <SkilsLi>
                            <img src={react} alt="" width='60px' height='60px' />
                            <SkilsText>React Js</SkilsText>
                            <SkilsLiUl>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={WhiteStart} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={WhiteStart} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                            </SkilsLiUl>
                        </SkilsLi>
                        <SkilsLi>
                            <img src={ps} alt="" width='60px' height='60px' />
                            <SkilsText>PhotoShop</SkilsText>
                            <SkilsLiUl>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={WhiteStart} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                            </SkilsLiUl>
                        </SkilsLi>
                        <SkilsLi>
                            <img src={figma} alt="" width='60px' height='60px' />
                            <SkilsText>Figma</SkilsText>
                            <SkilsLiUl>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={WhiteStart} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={WhiteStart} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                            </SkilsLiUl>
                        </SkilsLi>
                        <SkilsLi>
                            <img src={git} alt="" width='60px' height='60px' />
                            <SkilsText>Git</SkilsText>
                            <SkilsLiUl>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={WhiteStart} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={WhiteStart} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                            </SkilsLiUl>
                        </SkilsLi>
                        <SkilsLi>
                            <img src={github} alt="" width='60px' height='60px' />
                            <SkilsText>GitHub</SkilsText>
                            <SkilsLiUl>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={BlackStar} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={WhiteStart} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                                <SkilsLiLi>
                                    <img src={WhiteStart} alt="" width='20px' height='20px' />
                                </SkilsLiLi>
                            </SkilsLiUl>
                        </SkilsLi>
                    </SkilsUl>
                </Skils>

    )
}